"use client";
import { jsx } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import ArrowSVG from "./ArrowSVG.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverArrow_PopoverArrow = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = usePopoverMode();
    if ('drawer' === mode) return null;
    const { arrow } = popoverVariants();
    return /*#__PURE__*/ jsx(Popover.Arrow, {
        ref: ref,
        className: cn(arrow(), className, slots?.arrow),
        ...props,
        children: /*#__PURE__*/ jsx(ArrowSVG, {
            "data-testid": "arrowSvg"
        })
    });
});
export { PopoverArrow_PopoverArrow as PopoverArrow };
